var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-second-style"},[_c('UserOverview'),_c('CourseRecord'),_c('Revenue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }